module.exports = __webpack_public_path__ + "static/media/Dark Seer.52e2fcc0.png";